import Faq from "../../modules/faq/views/Faq.vue";
import { PermissionList } from "../../static-data/PermissionList";
import RouterViewRender from "../../utils/routes/router-view-render";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const FaqRoutes = {
  path: "perguntas-frequentes",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.FAQ_MENU),
  children: [
    {
      path: "",
      component: Faq,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default FaqRoutes;
